import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import * as _ from 'lodash-es';
import { AppService } from '../../../app.service';

@Injectable({
  providedIn: 'root'
})
export class FirFdiiQbaiExcludeAcctService {

  private get ssoId(): string {
    return this.appService.USER_SETTINGS?.user?.sso_id || '';
  }

  constructor(private http: HttpClient, private appService: AppService) {}

  saveFdiiQbaiAcctExclude(
    baseUrl: string,
    jsonObjDetails: any[],
    globalService: any,
    filterParams: any = {},
    rowData: any = {}
  ): Observable<any> {
    
    const url = baseUrl + "/saveJsonObject?action_code=zcbwdt";
    
    let params = _.merge({}, globalService || {}, filterParams);

    const jsonObj = jsonObjDetails;
    const jsonSettings = [{
      'tax_year': filterParams.tax_year || params.tax_year,
      'scenario': filterParams.scenario || params.scenario,
      'jcd_key': (globalService?.jcd_key === '' || globalService?.jcd_key === undefined) ? '250' : globalService?.jcd_key
    }];

    params.jsonObj = JSON.stringify(jsonObj);
    params.jsonSettings = JSON.stringify(jsonSettings);
    params.process_name = "saveFDIIQBAIAcctExcludeData";

    // Add missing required parameters that backend expects
    params.tax_year = filterParams.tax_year || params.tax_year;
    params.scenario = filterParams.scenario || params.scenario;
    params.jcd_key = filterParams.jcd_key || params.jcd_key || (globalService?.jcd_key === '' || globalService?.jcd_key === undefined) ? '250' : globalService?.jcd_key;
    params.scenarioCode = filterParams.scenarioCode || filterParams.scenario_code || params.scenarioCode || "RAF";
    params.is_issue_key_enabled = "N";

    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null) {
        urlEncoded.set(key, params[key].toString());
      }
    });

    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    });

    return this.http.post<any>(url, urlEncoded.toString(), { headers, withCredentials: true });
  }

  saveFdiiQbaiAmt(
    baseUrl: string,
    formData: any,
    globalService: any,
    filterParams: any = {},
    rowData: any = {}
  ): Observable<any> {
    // Legacy parity (fir-grid-save.service.ts pattern): AG Grid re-fires
    // cellEditingStopped on focus/blur even without an actual change. Without
    // this guard each navigation between cells produces a redundant POST,
    // a green "Data saved Successfully." snackbar and (when CALLBACK_METHOD
    // === 1 server-side) a full grid refresh that steals focus from the next
    // cell the user is trying to edit.
    if (!formData?.rowData || !formData?.col_id ||
        formData.rowData[formData.col_id] === formData?.oldRowData?.[formData.col_id]) {
      return of({ callSuccess: '1', skipped: true });
    }

    const url = baseUrl + "/saveJsonObject?action_code=b6qx17";

    let params = _.merge({}, globalService || {}, filterParams);

    const jsonObj = [{
      "tax_year": formData.rowData.TAX_YEAR,
      "leid": formData.rowData.LEID,
      "cdr_no": formData.rowData.CDR_NO,
      "me_code": formData.rowData.ME_CODE,
      "curr": formData.rowData.CURR,
      "reporting_period": formData.rowData.REPORTING_PERIOD,
      "col_type": formData.col_id,
      "col_value": formData.rowData[formData.col_id],
      "combination_key": formData.rowData.COMBINATION_KEY
    }];

    const jsonSettings = [{
      tax_year: filterParams.tax_year || params.tax_year,
      sso_id: this.ssoId,
      screen_key: globalService?.screen_key || ''
    }];

    params.jsonObj = JSON.stringify(jsonObj);
    params.jsonSettings = JSON.stringify(jsonSettings);
    params.object_id = formData.rowData.object_id;
    params.sso_id = this.ssoId;
    params.process_name = "saveFDIIQBAIManualData";

    const checkLockedbj = [{
      "leid": formData.rowData.LEID,
      "cdr_number": formData.rowData.CDR_NO,
      "consol_group_key": formData.rowData.CONSOL_GROUP_KEY,
      "reporting_period": formData.rowData.REPORTING_PERIOD,
      "combination_key": formData.rowData.COMBINATION_KEY,
      "scenario_key": parseInt(filterParams.scenario || params.scenario)
    }];
    params.checkLockedbj = JSON.stringify(checkLockedbj);

    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null) {
        urlEncoded.set(key, params[key].toString());
      }
    });

    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    });

    return this.http.post<any>(url, urlEncoded.toString(), { headers, withCredentials: true });
  }

  saveFdiiQbaiPtrAmt(
    baseUrl: string,
    formData: any,
    globalService: any,
    filterParams: any = {},
    rowData: any = {}
  ): Observable<any> {
    // Legacy parity (fir-grid-save.service.ts pattern): skip the round-trip
    // when AG Grid re-fires cellEditingStopped without a real value change.
    // Avoids spurious "saved Successfully" snackbars and CALLBACK_METHOD-driven
    // grid refreshes while the user is moving between cells.
    if (!formData?.rowData || !formData?.col_id ||
        formData.rowData[formData.col_id] === formData?.oldRowData?.[formData.col_id]) {
      return of({ callSuccess: '1', skipped: true });
    }

    const url = baseUrl + "/saveJsonObject?action_code=96icfq";

    let params = _.merge({}, globalService || {}, filterParams);

    const jsonObj = [{
      "tax_year": formData.rowData.TAX_YEAR,
      "pship_cc_key": formData.rowData.COMBINATION_KEY,
      "override_amt": formData.rowData.OVERRIDE,
      "override_alct_amt": formData.rowData.OVERRIDE_ALCT_AMT,
      "pre_alloc_amt": formData.rowData.PRE_ALLOC_AMT,
      "ptr_cc_key": formData.rowData.PTR_CC_KEY
    }];

    const jsonSettings = [{
      tax_year: filterParams.tax_year || params.tax_year,
      sso_id: this.ssoId,
      screen_key: globalService?.screen_key || ''
    }];

    params.jsonObj = JSON.stringify(jsonObj);
    params.jsonSettings = JSON.stringify(jsonSettings);
    params.object_id = formData.rowData.object_id;
    params.sso_id = this.ssoId;
    params.process_name = "saveFDIIQBAIPTRAmt";

    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null) {
        urlEncoded.set(key, params[key].toString());
      }
    });

    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    });

    return this.http.post<any>(url, urlEncoded.toString(), { headers, withCredentials: true });
  }
}
